"use client";
import React, { useEffect, useState } from "react";
import { usePathname } from "@/i18n/navigation";
const MetaTagGenerator = dynamic(
  () => import("./metaTagGenerator/MetaTagGenerator"),
  {
    ssr: false,
  }
);
const BarCodeGenerator = dynamic(
  () => import("./barcodeGenerator/barcodeGenrerator"),
  {
    ssr: false,
  }
);
const PasswordGenerator = dynamic(
  () => import("./passwordGenerator/PasswordGenerator"),
  {
    ssr: false,
  }
);
const PasswordStrengthChecker = dynamic(
  () => import("./passwordStrengthChecker/PasswordStrengthChecker"),
  {
    ssr: false,
  }
);
const QRCodeGenerator = dynamic(
  () => import("./qrCodeGenerator/QrCodeGenerator"),
  {
    ssr: false,
  }
);
const LoremIpsumGenerator = dynamic(
  () => import("./loremIpsumGenerator/LoremIpsumGenerator"),
  {
    ssr: false,
  }
);
const CreditCardNumberChecker = dynamic(
  () => import("./creditCardNumChecker/CreditCardNumberChecker"),
  {
    ssr: false,
  }
);
const QrCodeDecoder = dynamic(() => import("./qrCodeDecoder/QrCodeDecoder"), {
  ssr: false,
});
const StandupTimer = dynamic(() => import("./standupTimer/StandupTimer"), {
  ssr: false,
});
const TinnyTools = dynamic(() => import("./TinnyTools/TinnyTools"), {
  ssr: false,
});
import dynamic from "next/dynamic";
const MergePdf = dynamic(() => import("./MergePDF/pages/Merge"), {
  ssr: false,
});
const CountDownTimer = dynamic(
  () => import("./countDownTimer/CountDownTimer"),
  {
    ssr: false,
  }
);
const Pomodoro = dynamic(() => import("./pomodoro/Pomodoro"), {
  ssr: false,
});
const FaviconGenerator = dynamic(
  () => import("./FaviconGenerator/FaviconGenerator"),
  {
    ssr: false,
  }
);
const ColorPickerConverter = dynamic(
  () => import("./colorPickerConverter/ColorPickerConverter"),
  { ssr: false }
);
const RegexTester = dynamic(() => import("./regexTester/RegexTester"), {
  ssr: false,
});
const ColorMixer = dynamic(() => import("./colorMixer/ColorMixer"), {
  ssr: false,
});

function DevFormat() {
  const pathname = usePathname();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return null;
  }

  return (
    <>
      {typeof window !== "undefined" && (
        <>
          {pathname === "/meta-tag-generator" && <MetaTagGenerator />}
          {pathname === "/password-generator" && <PasswordGenerator />}
          {pathname === "/password-strength-checker" && <PasswordStrengthChecker />}
          {pathname === "/qr-code-generator" && <QRCodeGenerator />}
          {pathname === "/qr-code-decoder" && <QrCodeDecoder />}
          {pathname === "/barcode-generator" && <BarCodeGenerator />}
          {pathname === "/lorem-ipsum-generator" && <LoremIpsumGenerator />}
          {pathname === "/creditcard-number-checker" && <CreditCardNumberChecker />}
          {pathname === "/favicon-generator" && <FaviconGenerator />}
          {pathname === "/standup-timer" && <StandupTimer />}
          {pathname === "/countdown-timer" && <CountDownTimer />}
          {pathname === "/tiny-url" && <TinnyTools />}
          {pathname === "/merge-pdf" && <MergePdf />}
          {pathname === "/pomodoro" && <Pomodoro />}
          {pathname === "/color-picker-converter" && <ColorPickerConverter />}
          {pathname === "/regex-tester" && <RegexTester />}
          {pathname === "/color-mixer" && <ColorMixer />}
        </>
      )}
    </>
  );
}

export default DevFormat;
